/**
 * Schedule form: filter activity and instructor dropdowns by selected organization.
 * Reads preloaded data from json_script tags (activities-by-org, instructors-by-org).
 * Only runs when those elements and id_organization exist (schedule create/edit page).
 */
export function initScheduleFormCascading() {
  const orgSelect = document.getElementById('id_organization');
  const activitySelect = document.getElementById('id_activity');
  const instructorSelect = document.getElementById('id_instructor');
  if (!orgSelect || !activitySelect || !instructorSelect) return;

  const activitiesDataEl = document.getElementById('activities-by-org');
  const instructorsDataEl = document.getElementById('instructors-by-org');
  if (!activitiesDataEl || !instructorsDataEl) return;

  const activitiesByOrg = JSON.parse(activitiesDataEl.textContent || '{}');
  const instructorsByOrg = JSON.parse(instructorsDataEl.textContent || '{}');

  function rebuildOptions(selectEl, options, selectedValue) {
    selectEl.innerHTML = '';
    options.forEach((option) => {
      const opt = new Option(option.text, option.value);
      selectEl.add(opt);
    });
    if (selectedValue && options.some((o) => o.value === selectedValue)) {
      selectEl.value = selectedValue;
    }
  }

  function refreshForOrganization() {
    const orgId = orgSelect.value;
    const activityValue = activitySelect.value;
    const instructorValue = instructorSelect.value;

    if (!orgId) {
      rebuildOptions(activitySelect, [{ value: '', text: 'Select an activity' }], '');
      rebuildOptions(instructorSelect, [{ value: '', text: 'Select an instructor' }], '');
      return;
    }

    const activities = activitiesByOrg[orgId] || [];
    const instructors = instructorsByOrg[orgId] || [];

    const activityOptions = [
      { value: '', text: 'Select an activity' },
      ...activities.map((a) => ({ value: String(a.id), text: a.name })),
    ];
    const instructorOptions = [
      { value: '', text: 'Select an instructor' },
      ...instructors.map((i) => ({ value: String(i.id), text: i.name })),
    ];

    rebuildOptions(activitySelect, activityOptions, activityValue);
    rebuildOptions(instructorSelect, instructorOptions, instructorValue);
  }

  orgSelect.addEventListener('change', refreshForOrganization);

  if (orgSelect.value) {
    refreshForOrganization();
  }
}
